import { usePetitionDetailsPageData, usePetitionDetailsPageFcm } from 'src/app/pages/petitionGamma/details/pageContext';
import type { DecisionMaker } from 'src/app/pages/petitionGamma/details/shared/types';

type Result = ModelHookResult<{ showLegislativeBodies: boolean }>;

export function useDecisionMakerSection(): Result {
	const { decisionMakersLegislativeBodiesEnabled } = usePetitionDetailsPageFcm();

	const {
		data: {
			petition: {
				primaryDecisionMakerConnection: { nodes },
			},
		},
	} = usePetitionDetailsPageData();

	return {
		data: {
			showLegislativeBodies: decisionMakersLegislativeBodiesEnabled && legislativeBodiesPresent(nodes),
		},
	};
}

const legislativeBodiesPresent = (dms: readonly DecisionMaker[]) => {
	// counts dms that can be grouped.
	// returns true if there's at least one group
	const lbNames = new Set();

	for (const dm of dms) {
		const { title, type } = dm;
		if (type === 'POLITICIAN' && title) {
			const lb = title.split('-')[0].trim();
			if (lbNames.has(lb)) return true;
			lbNames.add(lb);
		}
	}
	return false;
};
